import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getBroadcasts = async () => {
try {
    const { data } = await axios.get<ApiResponse>(
    `${API_BASE_URL}/get_broadcasts/`
    );
    return data;
} catch (error) {
    return error;
}
};

const editBroadcasts = async (payload: any) => {
    try {
      const { data } = await axios.post<ApiResponse>(
        `${API_BASE_URL}/edit_broadcasts/`,
        payload
      );
      return data;
    } catch (error) {
      return error;
    }
};

const deleteBroadcasts = async (payload: any) => {
try {
const { data } = await axios.post<ApiResponse>(
`${API_BASE_URL}/delete_broadcasts/`,
payload
);
return data;
} catch (error) {
return error;
}
};

const publishBroadcasts = async (payload: any) => {
    try {
    const { data } = await axios.post<ApiResponse>(
    `${API_BASE_URL}/publish_broadcasts/`,
    payload
    );
    return data;
    } catch (error) {
    return error;
    }
    };

const createBroadcast = async (data: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/create_broadcast/`,
      data,
      config
    );
    return response.data;
  } catch (error) {}
};


const api = {
    getBroadcasts,
    editBroadcasts,
    deleteBroadcasts,
    publishBroadcasts,
    createBroadcast,
};

export default api;
